module.exports = __webpack_public_path__ + "static/media/starchHeavy.18963b47.svg";